import { useContext, useEffect, useRef, useState } from "react";
import { ReturnOfGOodsFromCustomersDto } from "../../../../dtos/documents/ReturnOfGoodsFromCustomers/ReturnOfGoodsFromCustomersDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { ReturnOfGoodsFromCustomersModel } from "../../../../models/Documents/ReturnOfGOodsFromCustomers/ReturnOfGoodsFromCustomersModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { importFromExcel, saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import ReturnOfGoodsFromCustomersDetailSkeleton from "./ReturnOfGoodsFromCustomersDetailSkeleton";
import { ReturnOfGoodsFromCustomersDetailMain } from "./ReturnOfGoodsFromCustomersDetailMain";
import { ReturnOfGoodsFromCustomersDetailProducts } from "./ReturnOfGoodsFromCustomersDetailProducts";
import { ReturnOfGoodsFromCustomersDetailAdditional } from "./ReturnOfGoodsFromCustomersDetailAdditional";
import { ReturnOfGoodsFromCustomersDetailFOoter } from "./ReturnOfGoodsFromCustomersDetailFOoter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: ReturnOfGOodsFromCustomersDto | null;
  modelUpdatedEvent: (newModel: ReturnOfGOodsFromCustomersDto) => void;
}

export const ReturnOfGoodsFromCustomersDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<ReturnOfGoodsFromCustomersModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Return Of Goods From Customers");

  const watchProducts = watch("returnOfGoodsFromCustomerGoods");

  useEffect(() => {
    register("returnOfGoodsFromCustomerGoods");
    if (model) {
      setValue("id", model.id);
      setValue("createdDate", model.createdDate);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("businessTransaction", model.businessTransaction);
      setValue("contractId", model.contractId);
      setValue("priceIncludeVat", model.priceIncludeVat);
      setValue("taxation", model.taxation);
      setValue("currencyId", model.currencyId);
      setValue("unitId", model.unitId);
      setValue("managerId", model.managerId);
      setValue("warehouseId", model.warehouseId);
      setValue("companyId", model.companyId);
      setValue("customerId", model.customerId);
      setValue("returnOfGoodsFromCustomerGoods", model.returnOfGoodsFromCustomerGoods);
    }
  }, [model]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: ReturnOfGoodsFromCustomersModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <ReturnOfGoodsFromCustomersDetailSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      documentNumber: model.documentNumber,
      contractId: model.contractId,
      currencyId: model.currencyId,
      unitId: model.unitId,
      warehouseId: model.warehouseId,
      companyId: model.companyId,
      customerId: model.customerId,
      returnOfGoodsFromCustomerGoods: model.returnOfGoodsFromCustomerGoods
    };
    saveObjectToExcel(data, fileName);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      setValue("documentNumber", data.documentNumber);
      setValue("contractId", data.contractId);
      setValue("currencyId", data.currencyId);
      setValue("unitId", data.unitId);
      setValue("warehouseId", data.warehouseId);
      setValue("companyId", data.companyId);
      setValue("customerId", data.customerId);
      setValue("returnOfGoodsFromCustomerGoods", data.returnOfGoodsFromCustomerGoods);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>
        <NFTabContainer index={0} currentIndex={tabIndex}>
          <ReturnOfGoodsFromCustomersDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <ReturnOfGoodsFromCustomersDetailProducts />
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <ReturnOfGoodsFromCustomersDetailAdditional />
        </NFTabContainer>
      </div>
      <ReturnOfGoodsFromCustomersDetailFOoter />
    </FormProvider>
  );
};
